module.exports = __webpack_public_path__ + "img/button-metamask.b188b9dc.svg";